"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmJSOfflineSigner = exports.CosmJSOfflineSignerOnlyAmino = void 0;
class CosmJSOfflineSignerOnlyAmino {
    constructor(chainId, keplr) {
        this.chainId = chainId;
        this.keplr = keplr;
    }
    getAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const key = yield this.keplr.getKey(this.chainId);
            return [
                {
                    address: key.bech32Address,
                    // Currently, only secp256k1 is supported.
                    algo: "secp256k1",
                    pubkey: key.pubKey,
                },
            ];
        });
    }
    signAmino(signerAddress, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.chainId !== signDoc.chain_id) {
                throw new Error("Unmatched chain id with the offline signer");
            }
            const key = yield this.keplr.getKey(signDoc.chain_id);
            if (key.bech32Address !== signerAddress) {
                throw new Error("Unknown signer address");
            }
            return yield this.keplr.signAmino(this.chainId, signerAddress, signDoc);
        });
    }
    // Fallback function for the legacy cosmjs implementation before the staragte.
    sign(signerAddress, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.signAmino(signerAddress, signDoc);
        });
    }
}
exports.CosmJSOfflineSignerOnlyAmino = CosmJSOfflineSignerOnlyAmino;
class CosmJSOfflineSigner extends CosmJSOfflineSignerOnlyAmino {
    constructor(chainId, keplr) {
        super(chainId, keplr);
        this.chainId = chainId;
        this.keplr = keplr;
    }
    signDirect(signerAddress, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.chainId !== signDoc.chainId) {
                throw new Error("Unmatched chain id with the offline signer");
            }
            const key = yield this.keplr.getKey(signDoc.chainId);
            if (key.bech32Address !== signerAddress) {
                throw new Error("Unknown signer address");
            }
            return yield this.keplr.signDirect(this.chainId, signerAddress, signDoc);
        });
    }
}
exports.CosmJSOfflineSigner = CosmJSOfflineSigner;
//# sourceMappingURL=cosmjs.js.map